import classNames from 'classnames'
import React, { CSSProperties } from 'react'
import styles from './index.module.less'

type Nav = {
    value:number,
    options: Array<any>,
    style?:CSSProperties,
    onChange?:(val:any, item:any)=>void,
}
export default ({ value, options, onChange, style }:Nav) => {
  return <nav className={styles.noviceRecommendationNav} style={style}>
    {
        options.map(item => <div className={classNames('navItem', { active: value === item.value })} key={item.value} onClick={() => onChange(item.value, item)}>
          <div className="navItemSerialNumber">{item.serialNumber}</div>
          <div className="navItemTitle">{item.label}</div>
        </div>)
    }
  </nav>
}
